class GgSales extends HTMLElement {
  constructor() {
    super();
    this.timerEl = this.querySelector(".gg-sales__timer");
    this.start = parseInt(this.dataset.start, 10);
    this.end = parseInt(this.dataset.end, 10);
    this.hasCountdown = !Number.isNaN(this.start) && !Number.isNaN(this.end);
  }

  connectedCallback() {
    if (!this.hasCountdown) {
      // Label-only sale: nothing to time, just show it.
      this.setAttribute("data-visible", "true");
      return;
    }

    this.tick();
    this.interval = setInterval(this.tick.bind(this), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const now = Date.now();

    // Only show while we're within the sale window.
    if (now < this.start || now > this.end) {
      this.setAttribute("data-visible", "false");
      if (now > this.end) clearInterval(this.interval);
      return;
    }

    if (this.timerEl) this.timerEl.textContent = this.format(this.end - now);
    this.setAttribute("data-visible", "true");
  }

  format(ms) {
    const totalSeconds = Math.floor(ms / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (n) => String(n).padStart(2, "0");

    return `${days}d ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
  }
}

customElements.define("gg-sales", GgSales);
